// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__XcJi-","tabs__panel":"Tabs_tabs__panel__CH7lx"};